import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import HeaderThin from 'app/components/layout/HeaderThin';
import CardGroup from 'app/components/general/CardGroup';
import Checkbox from 'app/components/general/Checkbox';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import {
  Label, Card,
  CardBody,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import Isvg from 'react-inlinesvg';
import SectionGroup from 'app/components/general/SectionGroup';

import SchemaForm from 'app/components/general/SchemaForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import organisationSizes from 'app/utils/static/organisationSizes';

import { getStripeSessions } from 'app/ducks/stripeSessions/selectors';
import { getOrganisationProducts } from 'app/ducks/organisationProducts/selectors';
import { getOrganisationSubscriptions } from 'app/ducks/organisationSubscriptions/selectors';
import { getOrganisations } from 'app/ducks/organisations/selectors';

import * as stripeSessionActions from 'app/ducks/stripeSessions/actions';
import * as organisationProductActions from 'app/ducks/organisationProducts/actions';
import * as organisationSubscriptionActions from 'app/ducks/organisationSubscriptions/actions';

import planSizes from 'app/utils/static/planSizes';

import { parseAmount } from 'app/utils/parsers';

import SizeSelector from './SizeSelector';
import ProductSelector from './ProductSelector';
import PriceSummary from './PriceSummary';

interface ISelectPlanProps {
  actions: any;
  organisations: any;
  stripeSessions: any;
  organisationProducts: any;
  organisationSubscriptions: any;
}

interface ISelectPlanState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  errors: any;
  size: string;
  selectedProducts: any;
  stage: string;
  numberOfTeams: {
    id: string;
    name: string;
  };
  billingFrequency: string;
}
export function selector(state) {
  return {
    stripeSessions: getStripeSessions(state),
    organisationProducts: getOrganisationProducts(state),
    organisationSubscriptions: getOrganisationSubscriptions(state),
    organisations: getOrganisations(state),
  };
}

const actionCreators = _.merge(stripeSessionActions, organisationProductActions, organisationSubscriptionActions);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  } as any),
)
export default class SelectPlan extends React.Component<ISelectPlanProps, ISelectPlanState> {
  static defaultProps: ISelectPlanProps = {
    actions: undefined,
    organisations: undefined,
    stripeSessions: undefined,
    organisationProducts: undefined,
    organisationSubscriptions: undefined,
  };

  state: ISelectPlanState = {
    originalFormData: {},
    formData: {
      size: _.find(organisationSizes, (size) => size.id === 'small'),
    },
    changed: false,
    saved: false,
    errors: {},
    size: undefined,
    stage: 'size',
    numberOfTeams: undefined,
    billingFrequency: '',
    selectedProducts: {
      plus: true,
    },
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed) {
      return {
        ...prevState,
        errors: nextProps.errors,
      };
    }
    return null;
  }

  componentDidMount(): void {
    this.props.actions.getAllOrganisationProducts();
    if (this.props.organisations.currentOrganisation?.hasActiveSubscriptionPlan) {
      history.push('/billing');
    }
  }

  isValid = (): boolean => !_.isEmpty(this.state.numberOfTeams)

  handleChange = (e): void => {
    const changed = this.state.originalFormData !== e.formData;
    this.setState(() => ({
      formData: e.formData,
      errors: [],
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleSubmit = (e): void => {
    const coreProduct = _.filter(this.props.organisationProducts.organisationProductsById, (o) => o.productType === 'core')[0];
    const plusProduct = _.filter(this.props.organisationProducts.organisationProductsById, (o) => o.productType === 'plus')[0];
    const advancedProduct = _.filter(this.props.organisationProducts.organisationProductsById, (o) => o.productType === 'advanced')[0];

    if (this.isValid()) {
      const organisationProducts = [];
      const stripeLineItems = [];
      if (this.state.selectedProducts.core) {
        organisationProducts.push({ id: coreProduct.id });
      }
      if (this.state.selectedProducts.plus) {
        organisationProducts.push({ id: plusProduct.id });
      }
      if (this.state.selectedProducts.advanced) {
        organisationProducts.push({ id: advancedProduct.id });
      }
      if (this.state.selectedProducts.core) {
        stripeLineItems.push({ price: coreProduct.monthlyPriceId, quantity: parseInt(this.state.numberOfTeams?.id) });
      }
      if (this.state.selectedProducts.plus) {
        stripeLineItems.push({ price: plusProduct.monthlyPriceId, quantity: parseInt(this.state.numberOfTeams?.id) });
      }
      if (this.state.selectedProducts.advanced) {
        stripeLineItems.push({ price: advancedProduct.monthlyPriceId, quantity: parseInt(this.state.numberOfTeams?.id) });
      }
      const payload = {
        organisationProducts,
        unitSize: this.state.numberOfTeams?.id,
        billingFrequency: 'monthly',
        organisation: {
          id: this.props.organisations.currentOrganisationId,
        },
      };

      // this.props.actions.createOrganisationSubscription(payload);
      this.props.actions.createStripeSession({
        sessionType: 'checkout',
        lineItems: stripeLineItems,
      });
    }
    this.setState({ changed: false });
  };

  handleSize = (e): void => {
    this.setState({ stage: 'select' });
  }


  handleStripeBilling = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.actions.createStripeSession({});
  }

  handleProductSelect = (product) => {
    this.setState((prevState) => ({
      selectedProducts: {
        [product]: true,
      },
    }));
  }

  compileLineItems = (coreProduct,
    plusProduct,
    advancedProduct) => {
    const items = [];
    if (this.state.selectedProducts.core) {
      items.push({
        name: 'Core Plan',
        amount: parseAmount(this.getProductPrice(coreProduct, this.state.numberOfTeams?.id)),
        rawAmount: this.getProductPrice(coreProduct, this.state.numberOfTeams?.id),
      });
    }
    if (this.state.selectedProducts.plus) {
      items.push({
        name: 'Plus Plan',
        amount: parseAmount(this.getProductPrice(plusProduct, this.state.numberOfTeams?.id)),
        rawAmount: this.getProductPrice(plusProduct, this.state.numberOfTeams?.id),
      });
    }
    if (this.state.selectedProducts.advanced) {
      items.push({
        name: 'Advanced Plan',
        amount: parseAmount(this.getProductPrice(advancedProduct, this.state.numberOfTeams?.id)),
        rawAmount: this.getProductPrice(advancedProduct, this.state.numberOfTeams?.id),
      });
    }
    return items;
  }

  totalAmount = (coreProduct,
    plusProduct,
    advancedProduct) => {
    const lineItems = this.compileLineItems(coreProduct,
      plusProduct,
      advancedProduct);
    const amount = _.sum(_.map(lineItems, (a) => a.rawAmount));
    return parseAmount(amount);
  }

  getProductPrice = (product, size) => product.monthlyPricePerUnitAmount * size

  handleFrequencySelect = (value) => {
    this.setState({ billingFrequency: value });
  }

  handleNumberOfTeamsChange = (value) => {
    this.setState({ numberOfTeams: value, stage: 'select' });
  }

  render(): React.ReactNode {
    const coreProduct = _.filter(this.props.organisationProducts.organisationProductsById, (o) => o.productType === 'core')[0];
    const plusProduct = _.filter(this.props.organisationProducts.organisationProductsById, (o) => o.productType === 'plus')[0];
    const advancedProduct = _.filter(this.props.organisationProducts.organisationProductsById, (o) => o.productType === 'advanced')[0];
    if (_.isEmpty(coreProduct)
      || _.isEmpty(plusProduct)
      || _.isEmpty(advancedProduct)) {
      return null;
    }
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              divider
              title="Billing"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="col">
                <SectionGroup title="Select Plan">
                  <div className="row">
                    <div className="col col-xl-8">
                      <div className="row">
                        <div className="col">
                          <CardGroup className={classnames('no-shadow-2')} title="1. Select Organisation size" isOpen>
                            <div className="row">
                              <div className="col">
                                <span className="normal-text">
                                  Select the number of teams that Teammo will be used for.
                                </span>
                              </div>
                            </div>
                            <div className="row margin-top">
                              <div className="col col-12 col-lg-4">
                                <InputGroupBlock
                                  type="select"
                                  labelText="Number of teams"
                                  name="numberOfTeams"
                                  placeholder="Number of teams"
                                  aria-label="Number of teams"
                                  autoComplete="off"
                                  radio
                                  formGroupClassName="centered"
                                  value={this.state.numberOfTeams}
                                  options={planSizes}
                                  onChange={(e) => this.handleNumberOfTeamsChange(e)}
                                />
                              </div>
                            </div>
                          </CardGroup>
                        </div>
                      </div>
                      <div className="row with-margin-top">
                        <div className="col">
                          <CardGroup className={classnames('no-shadow-2', { 'parent-collapse': this.state.stage !== 'select' })} title="2. Select plan" isOpen={this.state.stage === 'select'}>
                            <div className="row">
                              <div className="col with-margin-bottom-10">
                                <ProductSelector
                                  selected={this.state.selectedProducts.core}
                                  title={coreProduct.name}
                                  price={parseAmount(this.getProductPrice(coreProduct, this.state.numberOfTeams?.id))}
                                  description={coreProduct.description}
                                  handleSelect={() => this.handleProductSelect('core')}
                                />
                              </div>
                              <div className="col with-margin-bottom-10">
                                <ProductSelector
                                  selected={this.state.selectedProducts.plus}
                                  title={plusProduct.name}
                                  price={parseAmount(this.getProductPrice(plusProduct, this.state.numberOfTeams?.id))}
                                  description={plusProduct.description}
                                  handleSelect={() => this.handleProductSelect('plus')}
                                />
                              </div>
                              <div className="col with-margin-bottom-10">
                                <ProductSelector
                                  selected={this.state.selectedProducts.advanced}
                                  title={advancedProduct.name}
                                  price={parseAmount(this.getProductPrice(advancedProduct, this.state.numberOfTeams?.id))}
                                  description={advancedProduct.description}
                                  handleSelect={() => this.handleProductSelect('advanced')}
                                />
                              </div>
                            </div>
                            <div className="row with-margin-top">
                              <div className="col">
                                <span className="text-large text-weight-medium-bold">Transaction Fees</span>
                              </div>
                            </div>
                            <div className="row with-margin-top">
                              <div className="col">
                                <Card className="no-shadow-3">

                                  <CardBody>
                                    <div className="row">
                                      <div className="col text-weight-medium">
                                        Credit / debit cards
                                      </div>
                                      <div className="col text-weight-medium-bold text-right">
                                        1.9% + $0.10 per transaction
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </div>
                            </div>

                          </CardGroup>
                        </div>
                      </div>
                      <div className="row with-margin-top">
                        <div className="col">
                          <CardGroup className={classnames('no-shadow-2', { 'parent-collapse': this.state.stage !== 'select' })} title="3. Confirm plan" isOpen={this.state.stage === 'select'}>
                            <div className="row">
                              <div className="col">
                                <p>
                                  Number of teams and plan can be changed in the future, and you can also reach out to
                                  {' '}
                                  <a href="mailto:support@teammo.com.au">support@teammo.com.au</a>
                                  {' '}
                                  if you have any questions.
                                </p>
                                <p>
                                  Once confirmed you will be able to access invoices and billing information through our billing portal.
                                </p>
                              </div>
                            </div>
                            <div className="row with-margin-top">
                              <div className="col">
                                <Button className="btn btn-1 float-right" onClick={this.handleSubmit} disabled={!this.isValid()}>Confirm plan</Button>
                              </div>
                            </div>

                          </CardGroup>
                        </div>
                      </div>
                    </div>
                    <div className={classnames('col col-xl-4', { 'd-none': _.isEmpty(this.state.numberOfTeams) })}>
                      <PriceSummary
                        size={this.state.numberOfTeams?.name}
                        totalAmount={this.totalAmount(coreProduct,
                          plusProduct,
                          advancedProduct)}
                        lineItems={
                          this.compileLineItems(coreProduct,
                            plusProduct,
                            advancedProduct)
                        }
                      />
                    </div>
                  </div>
                </SectionGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
